import { useCallback, useMemo, useState } from 'react';

import { PlatformTableRelation, usePlatformTableListRelationsTeam } from '@cloudquery/api-platform';
import { useBaseAuthenticated } from '@cloudquery/base-users';
import Box from '@mui/material/Box';

import Stack from '@mui/material/Stack';

import { ApiDataWrapper, SearchField } from 'shared/base';

import { RelatedResourceTable } from './table';
import { CLOUD_ASSET_UNIQUE_KEY } from '../../../../constants/data';
import { AssetInventoryTableRow } from '../../../../types';
import { addQueryWhere } from '../../../../utils/tableState';

export const RelatedResources = ({ record }: { record?: AssetInventoryTableRow }) => {
  const { currentMembership } = useBaseAuthenticated();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const {
    data: relationsResponse,
    error,
    isLoading,
  } = usePlatformTableListRelationsTeam(
    currentMembership.team.name,
    record?.resource_type ?? '',
    undefined,
    {
      query: {
        enabled: !!record?.resource_type,
      },
    },
  );

  const relations = useMemo(() => {
    return (
      relationsResponse?.data?.data?.map((resource: PlatformTableRelation) => ({
        ...resource,
        query: addQueryWhere(resource.query, record?.[CLOUD_ASSET_UNIQUE_KEY] as string),
      })) ?? []
    );
  }, [relationsResponse, record]);

  const displayRelation = useCallback(
    (tableName: string) => {
      return tableName.toLowerCase().includes(searchTerm.toLowerCase());
    },
    [searchTerm],
  );

  return (
    <Stack gap={0} height="100%">
      <ApiDataWrapper
        data={relations}
        emptyTitle="No related resources"
        errorBoxProps={{
          attemptedAction: 'load related resources',
        }}
        isEmpty={relations.length === 0}
        isError={!!error}
        isLoading={isLoading}
      >
        {(data) => {
          return (
            <Stack gap={2} height="100%" p={0.25} sx={{ overflowY: 'auto' }}>
              <SearchField
                fullWidth={true}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClear={() => setSearchTerm('')}
                placeholder="Filter tables by name"
                size="small"
                value={searchTerm}
              />

              <Stack gap={0.5} sx={{ overflowY: 'auto' }}>
                {data
                  .sort((a, b) => a.label.localeCompare(b.label))
                  .map((relation: PlatformTableRelation) => (
                    <Box
                      key={relation.table_name}
                      display={displayRelation(relation.table_name) ? 'block' : 'none'}
                    >
                      <RelatedResourceTable
                        resource={relation}
                        // filter={[`${record?.resource_type}.[CLOUD_ASSET_UNIQUE_KEY] = '${record?.[CLOUD_ASSET_UNIQUE_KEY]}'`]}
                      />
                    </Box>
                  ))}
              </Stack>
            </Stack>
          );
        }}
      </ApiDataWrapper>
    </Stack>
  );
};
